export const FABRICS = [
  { name: "PC Matty", code: "CPP" },
  { name: "Spun Matty", code: "" },
  { name: "Nirmal Knit", code: "NK" },
  { name: "Dot Knit", code: "DK" },
  { name: "Micro PP", code: "MPP" },
  { name: "HoneyComb Polyester", code: "HC" },
  { name: "Plain Polyester", code: "PP" },
  { name: "HoneyComb Spun", code: "HCS" },
  { name: "PC Sinker", code: "SJ" },
  { name: "PC Pknit", code: "" },
  { name: "Sweat-Shirt Fleece", code: "CF" },
  { name: "Super Poly 220", code: "SP" },
  { name: "ICOP", code: "" },
  { name: "ICPOP", code: "" },
  { name: "4 Way Lycra", code: "4W" },
  { name: "Collar Cuff", code: "CC" },
  { name: "Cotton Rib", code: "CR" },
  { name: "Polyester Rib", code: "PR" },
  { name: "Diagonal Cricket", code: "" },
  { name: "Mesh", code: "" },
  { name: "NS Lycra", code: "NSL" },
  { name: "PoPi", code: "" },
  { name: "PUK", code: "" },
];

export const COLORS = [
  "Sky Blue",
  "Carbon Black / Dark Grey",
  "Ecru Melange",
  "Melange Grey / Light Grey",
  "T Green",
  "T Blue",
  "Navy Blue",
  "Apple Green",
  "Golden Yellow",
  "Mango Yellow",
  "Lemon Yellow",
  "Coffee",
  "Parrot Green",
  "Baby Pink",
  "Rani Pink",
  "Maroon",
  "White",
  "Royal Blue",
  "Light Royal Blue",
  "Bottle Green",
  "Red",
  "Purple",
  "Orange",
  "Black",
  "Aqua",
  "Camel",
  "Olive",
  "Lavender",
  "Light T Green",
  "Light Apple",
  "Denim",
  "Melange Bleach",
  "Pista",
];

export const SWATCHES = {
  "Sky Blue": "#87CEEB",
  "Carbon Black / Dark Grey": "#3A3A3A",
  "Ecru Melange": "#D6CFC0",
  "Melange Grey / Light Grey": "#B8B8B8",
  "T Green": "#00A19A",
  "T Blue": "#00B4D8",
  "Navy Blue": "#0A192F",
  "Apple Green": "#8DB600",
  "Golden Yellow": "#FFDF00",
  "Mango Yellow": "#FFC324",
  "Lemon Yellow": "#FFF44F",
  Coffee: "#6F4E37",
  "Parrot Green": "#7CFC00",
  "Baby Pink": "#F4C2C2",
  "Rani Pink": "#E30B5C",
  Maroon: "#800000",
  White: "#FFFFFF",
  "Royal Blue": "#4169E1",
  "Light Royal Blue": "#5B8DEF",
  "Bottle Green": "#006A4E",
  Red: "#DC143C",
  Purple: "#6A0DAD",
  Orange: "#FF8C00",
  Black: "#222222",
  Aqua: "#00E5E5",
  Camel: "#C19A6B",
  Olive: "#808000",
  Lavender: "#B57EDC",
  "Light T Green": "#7FD4C4",
  "Light Apple": "#C5E384",
  Denim: "#1560BD",
  "Melange Bleach": "#E8E6E1",
  Pista: "#93C572",
};

// slug for stable data-testids from fabric/color names
export const slug = (s) =>
  String(s)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

// Collar Cuff is sold in number of sets, not by weight
export const SET_FABRICS = ["Collar Cuff"];

// Display-only alphabetical sort of fabric objects/names (case-insensitive).
// Returns a NEW array — never mutates the input (no DB/data changes).
export const sortFabrics = (fabrics) =>
  [...(fabrics || [])].sort((a, b) => {
    const an = (typeof a === "string" ? a : a?.name || "").toLowerCase();
    const bn = (typeof b === "string" ? b : b?.name || "").toLowerCase();
    return an.localeCompare(bn);
  });

// Unit options an admin can assign to a fabric / non-fabric item.
export const UNIT_OPTIONS = ["kg", "pcs", "sets", "nos.", "packet", "rolls"];

// Data-driven unit map, populated from the backend fabrics list at runtime.
let UNIT_MAP = {};
export const setFabricUnits = (fabrics) => {
  const m = {};
  (fabrics || []).forEach((f) => { if (f && f.name && f.unit) m[f.name] = f.unit; });
  UNIT_MAP = m;
};
export const unitOf = (fabric) =>
  UNIT_MAP[fabric] || (SET_FABRICS.includes(fabric) ? "sets" : "kg");

// Date formatting — dd-mm-yyyy everywhere.
export function formatDate(input) {
  if (!input) return "";
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}/.test(input)) {
    const [y, m, d] = input.slice(0, 10).split("-");
    return `${d}-${m}-${y}`;
  }
  const dt = new Date(input);
  if (isNaN(dt.getTime())) return String(input);
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  return `${dd}-${mm}-${dt.getFullYear()}`;
}

export function formatDateTime(input) {
  if (!input) return "";
  const dt = new Date(input);
  if (isNaN(dt.getTime())) return String(input);
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const hh = String(dt.getHours()).padStart(2, "0");
  const mi = String(dt.getMinutes()).padStart(2, "0");
  return `${dd}-${mm}-${dt.getFullYear()} ${hh}:${mi}`;
}

export function stockStatus(kg, min_kg = 0) {
  // Out of stock when at or below the item's alert threshold (min_kg), not only
  // strictly zero — matches /api/arrivals so fractional leftovers read as OUT.
  if (kg <= (min_kg || 0)) return { label: "OUT", color: "#EF4444" };
  if (kg <= 10) return { label: "LOW", color: "#EAB308" };
  return { label: "IN STOCK", color: "#22C55E" };
}

// Evaluate a simple arithmetic formula (+ - * / parentheses decimals).
// Returns a Number, or null if invalid. Plain numbers pass through.
export function evalFormula(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim();
  if (s === "") return null;
  if (!/^[0-9+\-*/().\s]+$/.test(s)) return null;
  if (!/[0-9]/.test(s)) return null;
  try {
    // eslint-disable-next-line no-new-func
    const val = Function(`"use strict"; return (${s});`)();
    if (typeof val !== "number" || !isFinite(val)) return null;
    return Math.round(val * 1000) / 1000;
  } catch {
    return null;
  }
}

// Build { fabricName: [codes...] } from live colour data. The code is any token
// that appears before the first space in >=2 colour names under the same fabric
// (e.g. "DK White","DK Black" -> "DK"). The fabric's own `code` field is added too.
export function deriveFabricCodes(stock, fabrics) {
  const byFabric = {};
  (stock || []).forEach((s) => {
    if (!s || !s.fabric) return;
    (byFabric[s.fabric] = byFabric[s.fabric] || []).push(s.color || "");
  });
  // First pass: per-fabric candidate prefixes (token before first space, in >=2 colours).
  const derived = {};
  Object.entries(byFabric).forEach(([fabric, cols]) => {
    const counts = {};
    cols.forEach((c) => {
      const idx = String(c).indexOf(" ");
      if (idx > 0) {
        const prefix = String(c).slice(0, idx);
        if (/^[A-Za-z0-9]+$/.test(prefix)) counts[prefix] = (counts[prefix] || 0) + 1;
      }
    });
    derived[fabric] = Object.entries(counts).filter(([, n]) => n >= 2).map(([p]) => p);
  });
  // A prefix shared across more than one fabric (e.g. "Carbon") is generic, not a
  // fabric code — drop it so codes stay fabric-specific.
  const fabricsPerPrefix = {};
  Object.values(derived).forEach((arr) => arr.forEach((p) => { fabricsPerPrefix[p] = (fabricsPerPrefix[p] || 0) + 1; }));
  const map = {};
  Object.entries(derived).forEach(([fabric, arr]) => {
    map[fabric] = arr.filter((p) => fabricsPerPrefix[p] === 1);
  });
  // The fabric's explicitly assigned code always leads (used for display too).
  (fabrics || []).forEach((f) => {
    if (f && f.name && f.code) {
      map[f.name] = map[f.name] || [];
      map[f.name] = [f.code, ...map[f.name].filter((c) => c !== f.code)];
    }
  });
  return map;
}

// Case-insensitive, space-insensitive AND number-insensitive match on fabric
// name OR derived code OR colour. Spaces and digits are stripped from BOTH the
// query and the candidate before a substring test (display names never change),
// so "nkcamel" matches "NK 26 Camel" and "DK White" == "dkwhite" == "dk white".
// codeMap is the output of deriveFabricCodes (optional).
const _matchNorm = (s) => String(s || "").replace(/[\s\d]/g, "").toLowerCase();
export function itemMatchesQuery(item, query, codeMap) {
  const q = _matchNorm(query);
  if (!q) return true;
  const codes = (codeMap && codeMap[item.fabric]) || [];
  const candidates = [
    `${item.fabric} ${item.color}`,
    item.fabric,
    item.color,
    ...codes.map((c) => `${c} ${item.color}`),
    ...codes,
  ];
  return candidates.some((c) => _matchNorm(c).includes(q));
}

// The primary display code for a fabric (first derived/assigned code), or "".
export function fabricCodeLabel(fabric, codeMap) {
  const codes = (codeMap && codeMap[fabric]) || [];
  return codes.length ? codes[0] : "";
}
